import React, {useEffect, useState} from "react";
import { useNavigate } from "react-router-dom";
import Image from "../UI/Image";
import { FormatDate } from "../../utils/FormatDate";
import {postRequest} from "../../api/RequestSevices";
const CustomerListing = ({ users }) => {
  const [checked, setChecked] = useState({});
  const [allSelected, setAllSelected] = useState(false);
  const navigate = useNavigate();
  const [openPop, setOpenPop] = useState('');
  let selectAllCheckboxes = ()=> {
    setAllSelected(prevState => !prevState);
  }

  function handleCheckboxChange(userId) {
    let id = userId;
    if(!checked.hasOwnProperty(id)){
      setChecked({ ...checked, [id] : true});
    }
    else{
      if(checked[id]== false){
        setChecked({ ...checked, [id] : true});
      }
      else{
        setChecked({ ...checked, [id] : false});
      }
    }

  }
  // console.log(users[0]);

  return (
    <>
      {users?.[0] ? (
        <div className="customersList">
          <div className="dataTableDynamic">
            <table className="small" width="100%" border="0" cellSpacing="0" cellPadding="0">
              <tbody>
                <tr>
                  {/*<th width="1%" align="center">*/}
                  {/*  <div className="fSize0" onClick={selectAllCheckboxes}>*/}
                  {/*    <input*/}
                  {/*        type="checkbox"*/}
                  {/*        checked={allSelected}*/}
                  {/*    />*/}
                  {/*      <label htmlFor="454" className="noLabel"></label>*/}
                  {/*  </div>*/}
                  {/*</th>*/}
                  <th width="24%" align="left">Customer name</th>
                  <th width="24%" align="left">Email ID</th>
                  <th width="24%" align="left">Mobile no.</th>
                  <th width="24%" align="left">Vehicle</th>
                  <th width="13%" align="left"> &nbsp;</th>
                </tr>

                {
                  users.map((user, i)=>{
                  return(
                      <tr>
                          {/*<td align="center" className="vName">*/}
                          {/*  <div onClick={()=>handleCheckboxChange(user.user_id)}>*/}
                          {/*    {allSelected ?*/}
                          {/*        <input*/}
                          {/*            type="checkbox"*/}
                          {/*            checked={allSelected}*/}
                          {/*            // checked={user.user_id === checked.id ? true : false}*/}
                          {/*        />*/}
                          {/*        :*/}
                          {/*        <input*/}
                          {/*            type="checkbox"*/}
                          {/*            checked={checked[user.user_id]}*/}
                          {/*            // checked={user.user_id === checked.id ? true : false}*/}
                          {/*        />*/}
                          {/*    }*/}

                          {/*    <label htmlFor="4541">*/}
                          {/*    </label>*/}
                          {/*  </div>*/}
                          {/*</td>*/}
                        {user?.firstname || user?.lastname ? <td className="vName">{user.firstname.charAt(0).toUpperCase() + user.firstname.slice(1)} {user.lastname.charAt(0).toUpperCase() + user.lastname.slice(1)} </td>: <td>N/A</td>}
                        {user.email ?  <td>{user.email}</td> : <td>N/A</td>}
                        {user.phone ?  <td>{user.phone}</td> : <td>N/A</td>}
                        {/*{ user?.user_vehicle_package_info != undefined && user?.user_vehicle_package_info.length > 0 ?*/}
                        {/*  user.user_vehicle_package_info.map((data)=>{*/}
                        {/*  return(*/}
                        {/*      data?.model_name && data?.variant_name? <td>{data.model_name} {data.variant_name}<em>{data.package_name} ({data.minimum_battery_capacity}- {data.maximum_battery_capacity} kWh)</em></td> : <td>NA</td>*/}
                        {/*  )*/}
                        {/*    })*/}
                        {/*    :*/}
                        {/*    <td>NA</td>*/}
                        {/*    }*/}
                        {user?.user_vehicle_package_info != undefined && user?.user_vehicle_package_info.length > 0 ?
                            (user?.user_vehicle_package_info[0].model_name && user?.user_vehicle_package_info[0].variant_name
                                ?
                                <td>{user?.user_vehicle_package_info[0].model_name} {user?.user_vehicle_package_info[0].variant_name}
                                  {user?.user_vehicle_package_info[0]?.minimum_battery_capacity ==0 && user?.user_vehicle_package_info[0]?.maximum_battery_capacity == 10000
                                      ?
                                      <em>
                                        {user?.user_vehicle_package_info[0].package_name} (All battery type)
                                      </em>
                                      :
                                      (user?.user_vehicle_package_info[0].minimum_battery_capacity && user?.user_vehicle_package_info[0].maximum_battery_capacity ?

                                          <em>
                                            {user?.user_vehicle_package_info[0].package_name} ({user?.user_vehicle_package_info[0].minimum_battery_capacity}- {user?.user_vehicle_package_info[0].maximum_battery_capacity} kWh)
                                          </em>
                                          :
                                              <em>
                                                {user?.user_vehicle_package_info[0].package_name}
                                              </em>



                                      )
                                  }
                                  {user?.user_vehicle_package_info.length>1
                                      &&
                                      <p className="info" onClick={()=>{navigate(`/customerProfile/${user?.user_id}`);}}>
                                        ... +{user?.user_vehicle_package_info.length-1}
                                      </p>}
                                </td>
                                :
                                <td>NA</td>)
                            :
                            <td>NA</td>

                        }
                          <td className="right">
                            <div href="javascript:void(0);"  onClick={()=>{if(openPop==user.user_id){setOpenPop("")} else {setOpenPop(user.user_id)}}} className="actionNav">
                              {" "}
                              <i className="material-symbols-rounded mt-m grey">more_vert</i>
                              <div className="dropMenuWrap">
                                {openPop == user.user_id &&
                                  <ul className="dropMenu" style={{ width: 180 }}>
                                  {/* <li> <a href="javascript:void(0);">Active
                                            <label class="toggleSwitch">
                                              <input type="checkbox" checked="">
                                              <span class="slider round"></span> </label>
                                            </a> </li> */}

                                  <li onClick={() => {
                                    navigate(`/customerProfile/${user?.user_id}`);
                                  }}>
                                    {" "}
                                    <a href="javascript:void(0);">View details</a>{" "}
                                  </li>
                                  {/*<li>*/}
                                  {/*  {" "}*/}
                                  {/*  <a href="javascript:void(0);">Assign a promo</a>{" "}*/}
                                  {/*</li>*/}
                                </ul>}
                              </div>
                            </div>

                          </td>
                  </tr>
                  )
                    })


                }

              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <p>No users to Display</p>
      )}
    </>
  );
};
export default CustomerListing;
